var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlastBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 100,
    viewBox: "0 0 420 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_33542_286",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 420,
    height: 100
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 420,
    height: 100,
    rx: 8,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_33542_286)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 387,
    cy: 64,
    r: 49,
    fill: "#FCFC03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.573 77.9986H365.1C365.16 77.707 365.193 77.4071 365.281 77.1252C366.045 74.7107 366.82 72.299 367.588 69.8859C369.422 64.1158 371.256 58.3444 373.089 52.5729C373.431 51.4949 373.463 51.4825 374.391 52.1763C375.625 53.1008 376.856 54.0268 378.089 54.9528C379.117 55.7254 379.107 55.7226 378.724 56.9181C377.251 61.4996 375.781 66.0811 374.319 70.6654C374.087 71.3938 374.146 71.4684 374.908 71.4684C382.499 71.4725 390.088 71.4656 397.679 71.4795C398.289 71.4795 398.583 71.2486 398.761 70.6737C399.389 68.6518 400.063 66.6423 400.715 64.6272C401.311 62.7835 401.53 62.919 399.503 62.9176C394.649 62.9162 389.796 62.9176 384.944 62.9162C383.825 62.9162 383.788 62.8568 384.136 61.7719C384.474 60.7201 384.808 59.6656 385.148 58.6153C385.379 57.9021 385.879 57.5451 386.647 57.5442C391.799 57.5442 396.952 57.5331 402.103 57.5552C402.769 57.558 403.093 57.3299 403.285 56.6914C403.808 54.95 404.391 53.2266 404.95 51.4949C405.264 50.5205 405.239 50.4805 404.223 50.4805C399.486 50.4791 394.747 50.4805 390.01 50.4805C380.947 50.4805 371.885 50.4805 362.823 50.4749C362.54 50.4749 362.108 50.6201 362.013 50.3077C361.92 50.0037 362.362 49.8834 362.588 49.7134C365.123 47.8034 367.667 45.9031 370.208 44H407.478C409.28 45.3904 411.102 46.7517 413 48.008V48.2844C412.89 48.5622 412.763 48.8331 412.669 49.1164C411.936 51.3484 411.192 53.5763 410.495 55.8194C410.3 56.4454 409.952 56.8213 409.368 57.1047C407.193 58.1564 405.039 59.251 402.878 60.3318C402.066 60.7381 402.062 60.774 402.764 61.2951C404.114 62.2957 405.449 63.317 406.831 64.272C407.414 64.6742 407.509 65.0736 407.289 65.7218C406.607 67.7272 405.879 69.727 405.369 71.778C404.97 73.3812 404.175 74.4523 402.599 74.9401C402.36 75.0134 402.14 75.153 401.915 75.2691C400.139 76.1895 398.296 76.9787 396.572 78L396.573 77.9986Z",
    fill: "#F47226"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlastBg);
export default __webpack_public_path__ + "static/media/blast_bg.7c003d7395dc0b4032242be40b8a2804.svg";
export { ForwardRef as ReactComponent };